import PropTypes from 'prop-types'
import React from 'react'
import {
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap'
import classes from './Tabs.module.scss'
import { uncontrollable } from 'uncontrollable'

export class Tabs extends React.Component {
  static propTypes = {
    tabs: PropTypes.array.isRequired,
    className: PropTypes.string,
    small: PropTypes.bool,
    tabContainerProps: PropTypes.object,
    selectedTabId: PropTypes.string,
    onTabChange: PropTypes.func.isRequired
  }

  static defaultProps = {
    tabContainerProps: {}
  }

  constructor (props) {
    super(props)

    this.renderTabs = this.renderTabs.bind(this)
    this.renderView = this.renderView.bind(this)
  }

  componentDidMount () {
    this.setSelectedTabId()
  }

  componentDidUpdate () {
    this.setSelectedTabId()
  }

  setSelectedTabId () {
    const {
      selectedTabId,
      tabs,
      onTabChange
    } = this.props

    if (selectedTabId === undefined) {
      tabs[0] && onTabChange(tabs[0].id)
    }
  }

  renderTabs () {
    const {
      tabs,
      small,
      tabContainerProps,
      selectedTabId,
      onTabChange
    } = this.props

    let containerClassName = 'tab-nav ' + classes.tabContainer
    if (small) containerClassName += ' tab-nav-small'
    if (tabContainerProps.className) containerClassName += ' ' + tabContainerProps.className

    return (
      <ul
        {...tabContainerProps}
        className={containerClassName}
        role='tablist'
      >
        {tabs.map(tab => {
          const isSelected = selectedTabId === tab.id

          const onClick = (event) => {
            event.preventDefault()

            if (!isSelected) {
              onTabChange(tab.id)

              if (tab.onSelect) tab.onSelect()
            }
          }

          const className = isSelected ? 'active' : ''

          if (tab.tooltip) {
            return (
              <OverlayTrigger
                placement='top'
                overlay={
                  <Tooltip>
                    {tab.tooltip}
                  </Tooltip>
                }
              >
                <li key={tab.id} role='presentation' className={className}>
                  <a onClick={onClick}>{tab.title}</a>
                </li>
              </OverlayTrigger>
            )
          } else {
            return (
              <li key={tab.id} role='presentation' className={className}>
                <a onClick={onClick}>{tab.title}</a>
              </li>
            )
          }
        })}
      </ul>
    )
  }

  renderView () {
    const {
      tabs,
      selectedTabId
    } = this.props

    let view = null
    const length = tabs.length
    for (let i = 0; i < length; i++) {
      if (tabs[i].id === selectedTabId) {
        view = tabs[i].view
      }
    }

    return view
  }

  render () {
    const {
      tabs, // eslint-disable-line no-unused-vars
      className,
      small, // eslint-disable-line no-unused-vars
      tabContainerProps, // eslint-disable-line no-unused-vars
      onTabChange, // eslint-disable-line no-unused-vars
      ...props
    } = this.props

    let compClassName = classes.tabs
    if (className) compClassName += ' ' + className

    return (
      <div
        {...props}
        className={compClassName}
      >
        {this.renderTabs()}
        {this.renderView()}
      </div>
    )
  }
}

export default uncontrollable(
  Tabs,
  {
    selectedTabId: 'onTabChange'
  }
)
